import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation DeleteContactMediumMutation($id: String!) {
        deleteContactMedium(id:$id) {
            id
      }
    }
  `

export default (id, callback) => {
    const variables = {
        id
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.deleteContactMedium })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}